import script from "./EditIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__